import { PageEnum } from '@nami/domain/enums'
import pageAccessValidator from '@/middleware/pageAccessValidator'

const routes = [
    { path: '/', redirect: '/payment/deposit' },
    { path: '/payment/promotion/promowithdrawal', redirect: '/payment/promotion-progress' },
    {
        path: '/payment',
        redirect: '/payment/deposit',
        component: () => import('../views/Index.vue'),
        meta: { allowBack: false },
        children: [
            {
                path: 'withdraw/:any*',
                name: PageEnum[PageEnum.Withdraw].toLowerCase(),
                component: () => import('../views/WithdrawPage.vue'),
                meta: {
                    allowBack: false,
                    title: 'Withdraw',
                    middleware: [pageAccessValidator],
                },
            },
            {
                path: 'withdraw-processing',
                name: PageEnum[PageEnum.WithdrawProcessing].toLowerCase(),
                component: () => import('../views/WithdrawProcessing.vue'),
                meta: {
                    allowBack: false,
                    title: 'Withdraw',
                    middleware: [pageAccessValidator],
                },
            },
            {
                path: 'withdraw-reach-limit',
                name: PageEnum[PageEnum.WithdrawReachLimit].toLowerCase(),
                component: () => import('../views/WithdrawReachLimit.vue'),
                meta: {
                    allowBack: false,
                    title: 'Withdraw',
                    middleware: [pageAccessValidator],
                },
            },
            {
                path: 'deposit-before-withdraw',
                name: PageEnum[PageEnum.DepositBeforeWithdraw].toLowerCase(),
                component: () => import('../views/DepositBeforeWithdraw.vue'),
                meta: {
                    allowBack: false,
                    title: 'Withdraw',
                    middleware: [pageAccessValidator],
                },
            },
            {
                path: 'withdraw-no-available-payment',
                name: PageEnum[PageEnum.WithdrawNoAvailablePayment].toLowerCase(),
                component: () => import('../views/WithdrawNoAvailablePayment.vue'),
                meta: {
                    allowBack: false,
                    title: 'Withdraw',
                    middleware: [pageAccessValidator],
                },
            },

            {
                path: 'promotion-pending-deposit',
                name: PageEnum[PageEnum.PromotionPendingDeposit].toLowerCase(),
                component: () => import('../views/PromotionPendingDeposit.vue'),
                meta: {
                    allowBack: false,
                    title: 'Withdraw',
                    middleware: [pageAccessValidator],
                },
            },
            {
                path: 'promotion-progress',
                name: PageEnum[PageEnum.PromotionProgress].toLowerCase(),
                component: () => import('../views/PromotionProgress.vue'),
                meta: {
                    allowBack: false,
                    title: 'Withdraw',
                    middleware: [pageAccessValidator],
                },
            },
            {
                path: 'history',
                name: PageEnum[PageEnum.History].toLowerCase(),
                component: () => import('../views/HistoryPage.vue'),
                meta: {
                    allowBack: false,
                    title: 'History',
                },
            },
            {
                path: 'deposit/:any*',
                name: PageEnum[PageEnum.Deposit].toLowerCase(),
                component: () => import('../views/DepositPage.vue'),
                meta: {
                    allowBack: false,
                    title: 'Deposit',
                    middleware: [pageAccessValidator],
                },
            },
            {
                path: 'setting',
                meta: { allowBack: false, middleware: [pageAccessValidator] },
                children: [
                    {
                        path: 'otp',
                        name: PageEnum[PageEnum.Otp].toLowerCase(),
                        component: () => import('../views/OtpPage.vue'),
                        meta: {
                            allowBack: false,
                            title: 'Setting',
                        },
                    },
                    {
                        path: 'bank-account',
                        name: PageEnum[PageEnum.AddBankAccount].toLowerCase(),
                        component: () => import('../views/BankAccountSettingPage.vue'),
                        meta: {
                            title: 'Setting',
                        },
                    },
                    {
                        path: 'cpf',
                        name: PageEnum[PageEnum.Cpf].toLowerCase(),
                        component: () => import('../views/CpfPage.vue'),
                        meta: {
                            title: 'Setting',
                        },
                    },
                ],
            },
            {
                path: 'kyc-pending',
                name: PageEnum[PageEnum.KycPending].toLowerCase(),
                component: () => import('../views/KycReminder.vue'),
                meta: {
                    title: 'KYC',
                    middleware: [pageAccessValidator],
                },
            },
            {
                path: 'error',
                name: 'error',
                component: () => import('../views/GeneralErrorPage.vue'),
                meta: {
                    title: 'Error',
                },
            },
            {
                path: 'test-withdrawable-area-v2',
                name: 'test-withdrawable-area-v2',
                component: () => import('../views/WithdrawableAreaV2.vue'),
                meta: {
                    title: 'Test WithdrawableAreaV2',
                    // No middleware - skip all validations for testing
                },
            },
        ],
    },
]

export default routes
